var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueMutable,
            expression: "valueMutable"
          }
        ],
        staticClass: "form-control",
        on: {
          change: [
            function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.valueMutable = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            function($event) {
              return _vm.changeValue()
            }
          ]
        }
      },
      _vm._l(_vm.parameter.options, function(option) {
        return _c(
          "option",
          { key: "option" + option.value, domProps: { value: option.value } },
          [_vm._v(" " + _vm._s(option.name || option.value) + " ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }